import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import MuiSelect from '@material-ui/core/Select';
import { Field } from 'formik';
import { Select } from 'formik-material-ui';
import {
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  FormHelperText,
} from '@material-ui/core';
import { masterData } from './../../../constants';
import * as selectDepartmentAction from '../../../actions/selectDepartment.action';
import { useDispatch, useSelector } from 'react-redux';
import { SignalCellularNullOutlined } from '@material-ui/icons';

// Prototype permissionGroups Data
//const permissionLevels = masterData.permissionLevels;
/**
 * SelectPermissionLevel() (component)
 * @param {string} name, name of select element (default: category_id)
 * @param {string} id, id of select element (default: category_id)
 * @param {string} label, label of select element (default: "ประเภทของข้อมูลส่วนบุคคลที่มีการละเมิด")
 * @param {function} onChange, onChange
 * @param {string|number} value, value of select element
 * @param {Formik.touched} touched
 * @param {Formik.errors} errors
 * @param {object} className, className of select element
 * @returns (element) SelectPermissionLevel
 */
const SelectDepartment = ({
  name = 'department_id',
  id = 'department_id',
  label = ['ส่วนงาน', 'ภาควิชา'],
  onChange,
  value,
  touched,
  errors,
  className,
}) => {
  const [selectedValue, setSelectedValue] = useState(value);
  const [selectedValue2, setSelectedValue2] = useState('');
  const [selectedValue3, setSelectedValue3] = useState('');
  const [fullDepartmentTh, setFullDepartmentTh] = useState('');
  const [department, setDepartment] = useState([]);
  const [showDept, setShowDep] = useState([
    { show: true, level: 1 },
    { show: false, level: 2 },
    { show: false, level: 3 },
  ]);
  const dispatch = useDispatch();
  const SelectDepartmentReducer = useSelector(
    ({ SelectDepartmentReducer }) => SelectDepartmentReducer
  );
  const SelectDepartment2Reducer = useSelector(
    ({ SelectDepartment2Reducer }) => SelectDepartment2Reducer
  );
  const SelectDepartment3Reducer = useSelector(
    ({ SelectDepartment3Reducer }) => SelectDepartment3Reducer
  );

  const loadDepartment = async () => {
    await dispatch(selectDepartmentAction.loadDepartment());
  };
  const loadDepartment2 = async (value) => {
    await dispatch(selectDepartmentAction.loadDepartment2(value));
  };
  const loadDepartment3 = async (value) => {
    await dispatch(selectDepartmentAction.loadDepartment3(value));
  };

  useEffect(() => {
    loadDepartment();
  }, []);

  // Handle change select
  const memoHandleChange = useCallback((lvl, e, c) => {
    let context = typeof c.props.children === 'string' ? c.props.children : '';
    onChange && onChange(e.target.value, context);
    let objDep = SelectDepartmentReducer.result.content
      ? SelectDepartmentReducer.result.content
      : [];
    setSelectedValue(e.target.value);

    let obj = objDep.find((o) => o.id == e.target.value);
    let fullNameTh = obj?.fullNameTh
      ? JSON.parse(obj.fullNameTh).join(' ')
      : null;
    setFullDepartmentTh(fullNameTh);

    /* if (lvl == 2 && e.target.value == '') {
      onChange && onChange(selectedValue, context); // return data department1
    } else {
      onChange && onChange(e.target.value, context);
    }
   */
    // Handle state selectedValue.
    // let objDep = [];
    // let tmp = showDept;
    /*
    if (lvl == 1) {
      setSelectedValue(e.target.value);
      tmp[0].show = true;
      tmp[1].show = true;
      // tmp[2].show = false;
      console.log(e.target.value);

      if (e.target.value == '') {
        loadDepartment2('No-Key-Select');
        setSelectedValue2('');
      } else {
        loadDepartment2(e.target.value);
      }

      objDep = SelectDepartment2Reducer.result.content
        ? SelectDepartmentReducer.result.content
        : [];
    } else if (lvl == 0) {
      tmp[0].show = true;
      tmp[1].show = false;
      objDep = SelectDepartmentReducer.result.content
        ? SelectDepartmentReducer.result.content
        : [];
      setShowDep(tmp);
      console.log(showDept);
      let obj = objDep.find((o) => o.id == e.target.value);
      let fullNameTh = obj.fullNameTh
        ? JSON.parse(obj.fullNameTh).join(' ')
        : null;
      setFullDepartmentTh(fullNameTh);
    } else {
      setSelectedValue2(e.target.value);
    }*/
  });

  return (
    <React.Fragment>
      <FormControl
        fullWidth
        disabled={true}
        error={errors && touched ? true : false}
        className={className}
      >
        <InputLabel htmlFor={id}>{label[0]}</InputLabel>
        <Field
          component={Select}
          name={name}
          inputProps={{
            id,
            name,
          }}
          value={selectedValue}
          onChange={(e, c) => memoHandleChange(1, e, c)}
        >
          <MenuItem value="">
            <em>เลือก {label[0]}</em>
          </MenuItem>
          {SelectDepartmentReducer.result.content.map((dep) => (
            <MenuItem value={dep.keyCode} key={dep.keyCode}>
              {dep.nameTh}
            </MenuItem>
          ))}
        </Field>
        <span>{fullDepartmentTh}</span>
        <FormHelperText>{touched && errors && errors}</FormHelperText>
      </FormControl>

      {/* {selectedValue != '' ? (
        <FormControl
          fullWidth
          disabled={true}
          error={errors && touched ? true : false}
          className={className}
        >
          <InputLabel htmlFor={id + '1'}>{label[1]}</InputLabel>
          <Field
            component={Select}
            name={name + '1'}
            inputProps={{
              id: id + '1',
              name,
            }}
            value={selectedValue2}
            onChange={(e, c) => memoHandleChange(2, e, c)}
          >
            <MenuItem value="">
              <em>เลือก {label}</em>
            </MenuItem>
            {SelectDepartment2Reducer.result.content.map((dep) => (
              <MenuItem value={dep.id} key={dep.id}>
                {dep.nameTh}
              </MenuItem>
            ))}
          </Field>
         
          <FormHelperText>{touched && errors && errors}</FormHelperText>
        </FormControl>
      ) : null} */}
    </React.Fragment>
  );
};

// Types[, Rules] of props
SelectDepartment.propTypes = {
  name: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};


export default React.memo(SelectDepartment);
